<template>
  <div styleName="opt_wrap" ref="pptWrap" :style="style" :data-role="roomDetail.data.roomRole">
    <slot></slot>
    <div styleName="hongbao_modal_success" v-if="giftModalShow">
      <div styleName="hongbao_modal_success_header">
        <span styleName="header_icon"></span>
        <span styleName="header_title">{{header_title}}</span>
        <span styleName="header_close" @click="handleClosemodal">Turning off in {{modelHeaderClose}}S</span>
      </div>
      <div styleName="hongbao_modal_success_content">
        {{modelContent}}
      </div>
    </div>
  </div>
</template>

<script>
import EleResize from '../../utils/divResize'
import { mapGetters, mapMutations } from 'vuex'
import CSSModules from 'vue-css-modules'
import styles from './index.scss'
const pptWrapElePaddingTop = 50
const pptWrapElePaddingLeft = 35

export default {
  name: 'ResizeWrapper',
  mixins: [CSSModules(styles)],
  data () {
    return {
      width: 640,
      height: 480,
      scale: 480 / 640,
      modelHeaderClose: 5,
      modelContent: '',
      timer: null,
      header_title: ''
    }
  },
  computed: {
    ...mapGetters(['roomDetail', 'giftModalShow', 'giftStudentSuccess', 'hongbaoInfo', 'hongbaoStudentInfo']),
    style () {
      return `width: ${this.width}px; height: ${this.height}px`
    },
    pptWrapEle () {
      return this.$refs.pptWrap.parentElement
    },
    hongbaoHaveSendNum () {
      // 已经发送的红包数
      return this.hongbaoInfo && (this.hongbaoInfo.totalNum - this.hongbaoInfo.validNum)
    }
  },
  watch: {
    giftModalShow (val) {
      if (val) {
        console.log('this.hongbaoHaveSendNum', this.hongbaoHaveSendNum)
        if (!this.hongbaoHaveSendNum) {
          // 接口请求失败
          this.header_title = this.$t('hongbao_student_total_headertext_normal')
          this.modelContent = ''
        }
        this.timer = setInterval(() => {
          this.modelHeaderClose--
          if (this.modelHeaderClose <= 0) {
            this.modelHeaderClose = 0;
            this.$store.commit('STUDENT_GIFT_MODEL_SHOW', false)
            clearInterval(this.timer)
          }
        }, 1000)
      } else {
        this.modelHeaderClose = 5
      }
    },
    hongbaoStudentInfo (val) {
      console.log('val', val)
      if (val) {
        this.modelHeaderNum = val.studentNum
        if (val.studentNum === 0) {
          this.header_title = this.$t('hongbao_student_total_headertext_normal')
          this.modelContent = ''
        } else {
          this.header_title = val.studentNum + this.$t('hongbao_student_total_headertext')
          if (val.studentList.length === 0) {
            this.modelContent = ''
          } else {
            let str = val.studentList.join(',')
            this.modelContent = `${str}` + this.$t('hongbao_student_total_list')
          }
        }
      }
    }
  },
  mounted () {
    this.calcDynamic()
    this.addAllListeners()
  },
  beforeDestroy () {
    this.removeAllListeners()
  },
  methods: {
    ...mapMutations({
      setPPTSize: 'SET_PPT_SIZE',
      STUDENT_GIFT_MODEL_SHOW: 'STUDENT_GIFT_MODEL_SHOW'
    }),
    handleClosemodal () {
      this.$store.commit('STUDENT_GIFT_MODEL_SHOW', false)
      this.timer && clearInterval(this.timer)
    },
    addAllListeners () {
      EleResize.on(this.pptWrapEle, this.calcDynamic)
    },
    removeAllListeners () {
      EleResize.off(this.pptWrapEle, this.calcDynamic)
    },
    calcDynamic () {
      let calcFunc = () => {
        let dynamicWpParentInfo = this.pptWrapEle.getBoundingClientRect()
        this.height = dynamicWpParentInfo.height - pptWrapElePaddingTop * 2
        this.width = this.height / this.scale
        if (this.width >= dynamicWpParentInfo.width - pptWrapElePaddingLeft * 2) {
          this.width = dynamicWpParentInfo.width - pptWrapElePaddingLeft * 2
          this.height = this.width * this.scale
        }
        this.$nextTick(() => {
          let pptWrapInfo = this.$refs.pptWrap.getBoundingClientRect()
          this.setPPTSize({
            width: this.width, height: this.height,
            top: pptWrapInfo.top, left: pptWrapInfo.left,
            parentWidth: dynamicWpParentInfo.width
          })
        })
      }
      window.requestAnimationFrame(calcFunc)
    }
  }
}
</script>
